/* Magento Categories Store */

import {
    fetchMagentoCategories,
    bulkCategorizeProducts,
    fetchBulkMagentoCategoryJobs,
    fetchBulkMagentoJob
} from '@/api'
import {deleteBulkMagentoCategoryJob} from "../../api";

const state = {
    categories: [],
    jobs: [],
    job: {}
}

const actions = {
    fetchCategories (context, payload) {
        return fetchMagentoCategories(payload).then((r) => {
            return context.commit('setCategories', r.data)
        })
    },
    bulkCategorizeProducts (context, payload) {
        return bulkCategorizeProducts(payload)
    },
    fetchCategoryJobs (context, payload) {
        return fetchBulkMagentoCategoryJobs(payload).then(r => {
            return context.commit('setCategoryJobs', r.data)
        })
    },
    fetchCategoryJob (context, payload) {
        return fetchBulkMagentoJob(payload).then(r => {
            return context.commit('setCategoryJob', r.data)
        })
    },
    deleteCategoryJob (context, payload) {
        return deleteBulkMagentoCategoryJob(payload)
    }
}

const mutations = {
    setCategories (state, payload) {
        state.categories = payload['magentoResponse']['children_data']
    },
    setCategoryJobs (state, payload) {
        state.jobs = payload
    },
    setCategoryJob (state, payload) {
        state.job = payload['magentoResponse']
    }
}

const getters = {
    getCategories (state) {
        return state.categories
    },
    getCategoryJobs (state) {
        return state.jobs
    },
    getCategoryJob (state) {
        return state.job
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
